module.exports = __webpack_public_path__ + "img/erweima.468cf2c8.png";